export const PAGE_CONSTANTS = {
    VAS_PAGE: "CAR24_COVER",
    CDP: "CDP",
    EXTENDED_WARRANTY_PLAN: "EXTENDED_WARRANTY_PLAN",
    CAR_COVER_BUNDLES: "CAR_COVER_BUNDLES"
};
